import { useCallback } from 'react'

import { useDismissAllEngagementsByChannelIds } from './useDismissAllEngagementsByChannelIds'

export type UseDismissAllMentionsResult = {
  dismissAllMentions: (channelIds: string[], toDate?: string) => Promise<void>
  loading: boolean
}

/**
 * Mention-specific specialization over `useDismissAllEngagementsByChannelIds`.
 * Hardcodes `engagementType: 'mention'` so call sites stay readable
 * (`dismissAllMentions(channelIds, toDate)` instead of the kind-agnostic shape).
 *
 * When comments migrates off the legacy `dismissAllComments…` mutations, mirror
 * this file as `useDismissAllComments` — same wrapper pattern, swap the
 * engagementType.
 */
export const useDismissAllMentions = (): UseDismissAllMentionsResult => {
  const { dismissAllEngagementsByChannelIds, loading } =
    useDismissAllEngagementsByChannelIds()

  const dismissAllMentions = useCallback(
    (channelIds: string[], toDate?: string): Promise<void> =>
      dismissAllEngagementsByChannelIds({
        channelIds,
        engagementType: 'mention',
        toDate,
      }),
    [dismissAllEngagementsByChannelIds],
  )

  return { dismissAllMentions, loading }
}
